let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ejfa9")).then(() => parcelRequire('fP0nh'));